import { useDispatch } from "react-redux";

import {
  getLocalesData,
  clearLocalesState,
  getTagsListData,
  createTagData,
  clearTagsListState,
  clearTagsCreateState,
  getTagsOptionsData,
  clearTagsOptionsState,
} from "./index";

export const useCommonAdmin = () => {
  const dispatch = useDispatch();

  const getLocales = (data:any) => dispatch(getLocalesData(data));
  const clearLocales = () => dispatch(clearLocalesState());

  const getTagsList = (data: any) => dispatch(getTagsListData(data));
  const createTag = (data: any) => dispatch(createTagData(data));
  const clearTagsList = () => dispatch(clearTagsListState());
  const clearTagsCreate = () => dispatch(clearTagsCreateState());

  const getTagsOptions = (data: any) => dispatch(getTagsOptionsData(data));
  const clearTagsOptions = () => dispatch(clearTagsOptionsState());

  return {
    getLocales,
    clearLocales,
    getTagsList,
    createTag,
    clearTagsList,
    clearTagsCreate,
    getTagsOptions,
    clearTagsOptions,
  }
}
